/* eslint-disable prefer-template */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */

import { useEffect, useState } from "react";
import './transaction.css'
import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import Stack from '@mui/material/Stack';
import axios from "axios";
import moment from 'moment';
import Skeleton from '@mui/material/Skeleton';
import Subcription from "../Subcription/Subcription";

const Transaction = () => {

    const [data, setData] = useState(null);
    const [posts, SetPosts] = useState(data);
    const [postPerPage, SetPostPerPage] = useState(5);
    const [currentPage, SetCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);


    const [pageItem, SetPageItem] = useState({
        start: 0,
        end: postPerPage
    })

    const onPageChangeEvent = (start, end) => {
        SetPageItem({
            start: start,
            end: end
        })
    }

    const OnPerPostChangeEvent = (e) => {
        SetPostPerPage(e.target.value);
        SetCurrentPage(1);
    }



    const numOfPages = Math.ceil(posts?.length / postPerPage);
    // console.log(numOfPages);

    const numOfButtons = [];
    for (let i = 1; i <= numOfPages; i++) {
        numOfButtons.push(i);
    }

    const prevPageClick = () => {
        if (currentPage === 1) {
            SetCurrentPage(currentPage);
        } else {
            SetCurrentPage(currentPage - 1);
        }
    }


    const nextPageClick = () => {
        if (currentPage === numOfButtons.length) {
            SetCurrentPage(currentPage);
        } else {
            SetCurrentPage(currentPage + 1);
        }
    }

    const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

    useEffect(() => {
        let tempNumberOfButtons = [...arrOfCurrButtons]

        let dotsInitial = '...'
        let dotsLeft = '... '
        let dotsRight = ' ...'

        if (numOfButtons.length < 6) {
            tempNumberOfButtons = numOfButtons
        }

        else if (currentPage >= 1 && currentPage <= 3) {
            tempNumberOfButtons = [1, 2, 3, 4, dotsInitial, numOfButtons.length]
        }

        else if (currentPage === 4) {
            const sliced = numOfButtons.slice(0, 5)
            tempNumberOfButtons = [...sliced, dotsInitial, numOfButtons.length]
        }

        else if (currentPage > 4 && currentPage < numOfButtons.length - 2) {
            // from 5 to 8 -> (10 - 2)
            const sliced1 = numOfButtons.slice(currentPage - 2, currentPage)
            // sliced1 (5-2, 5) -> [4,5] 
            const sliced2 = numOfButtons.slice(currentPage, currentPage + 1)
            // sliced1 (5, 5+1) -> [6]
            tempNumberOfButtons = ([1, dotsLeft, ...sliced1, ...sliced2, dotsRight, numOfButtons.length])
            // [1, '...', 4, 5, 6, '...', 10]
        }

        else if (currentPage > numOfButtons.length - 3) {
            // > 7
            const sliced = numOfButtons.slice(numOfButtons.length - 4)
            // slice(10-4) 
            tempNumberOfButtons = ([1, dotsLeft, ...sliced])
        }

        else if (currentPage === dotsInitial) {
            // [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3 
            // arrOfCurrButtons[3] = 4 + 1 = 5
            // or 
            // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
            // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
            SetCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1)
        }
        else if (currentPage === dotsRight) {
            SetCurrentPage(arrOfCurrButtons[3] + 2)
        }

        else if (currentPage === dotsLeft) {
            SetCurrentPage(arrOfCurrButtons[3] - 2)
        }

        setArrOfCurrButtons(tempNumberOfButtons);
        const value = currentPage * postPerPage;

        onPageChangeEvent(value - postPerPage, value)
    }, [currentPage, postPerPage, numOfPages]);


    useEffect(() => {
        setLoading(true)
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`https://api.agentsuite.ai/api/v1/call/outbound/logs?locationId=1DlSNwTxwh6m3t3V2acG`, {
                    headers: {
                        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MDk2MzA3NDl9.-qwojdwBekvadXABVlCwwAiW-mQFsDYcGZPZOdWK_AM`,
                    },
                });
                setData(response.data);
                SetPosts(response.data);
                setLoading(false)
                console.log(response, "this is the response");
            } catch (error) {
                setLoading(false)
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const exportToExcel = () => {
        if (!data) return;

        const filteredData = data.map(({ id, callTimestamp, callDescription, callAmount, walletBalance, createdAt }) => ({ id, callTimestamp, callDescription, callAmount, walletBalance, createdAt })); // Example: Exporting only 'id' and 'name'

        const csvContent = "data:text/csv;charset=utf-8," +
            "ID,BILLING DATE,DESCRIPTION,AMOUNT,TOTAL BALANCE,DATE\n" + // Column names
            filteredData.map(row => Object.values(row).join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "data.csv");
        document.body.appendChild(link);
        link.click();

    }
    const loader = [1, 2, 3, 4, 5]

    return (
        <>
            <div className="transaction-card">
                <Subcription />
                <div className="">
                    <>
                        <div className="container-fluid mt-5 mb-5">
                            <div className="row justify-content-center">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div className="d-flex justify-content-between py-3">
                                                <div>
                                                    <select className="form-select ms-5" aria-label="Default select example">
                                                        <option selected>Per Page</option>
                                                        <option value="10">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                    </select>
                                                </div>
                                                <div className="button-export me-5">
                                                    <Stack direction="row" spacing={2}>
                                                        <Button variant="outlined" startIcon={<IosShareRoundedIcon />} onClick={exportToExcel}>
                                                            Export
                                                        </Button>
                                                    </Stack>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-text-small mb-0">
                                                    <thead className="thead-primary table-sorting">
                                                        <tr>
                                                            <th className="text-muted " style={{fontSize: '16px', fontWeight: "700",textAlign:"center", }}>ID</th>
                                                            <th className="text-muted " style={{ fontSize: '16px',fontWeight: "700",textAlign:"center",  }}>BILLING DATE</th>
                                                            <th className="text-muted " style={{ fontSize: '16px',fontWeight: "700", textAlign: "center" }}>DESCRIPTION</th>
                                                            <th className="text-muted " style={{ fontSize: '16px',fontWeight: "700",textAlign:"center" }}>AMOUNT</th>
                                                            <th className="text-muted " style={{ fontSize: '16px',fontWeight: "700",textAlign:"center" }}>TOTAL BALANCE</th>
                                                            <th className="text-muted " style={{ fontSize: '16px',fontWeight: "700",textAlign:"center" }}>DATE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ?
                                                            loader?.map((e) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td> <Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                            <td><Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                            <td><Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                            <td><Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                            <td><Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                            <td><Skeleton variant="text" width={"100%"} height={40} /></td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                            :

                                                            posts?.slice(pageItem.start, pageItem.end).map((data, index) => {
                                                                return (
                                                                    <tr key={data.id} style={{ width: "100%",height:"1vh" }} className="">
                                                                        <td className="text-success " style={{  fontSize: '18px', padding: '10px 10px 10px 10px', fontWeight: "400",textAlign:"center" }}>{data.id}</td>
                                                                        <td className="text-dark" style={{  fontSize: '18px', fontWeight: "500", padding: '10px 10px 10px 10px',textAlign:"center" }}>{moment(data.callTimestamp).format('MMMM Do YYYY, h:mm:ss a')}</td>
                                                                        <td className="text-dark" style={{  fontSize: '18px', textAlign: "center", padding: '10px 10px 10px 10px', fontWeight: "500" }}>{data.callDescription}</td>
                                                                        <td className="text-danger" style={{  fontSize: '18px', padding: '10px 10px 10px 10px', fontWeight: "bolder",textAlign:"center" }}>${data.callAmount}</td>
                                                                        <td className="text-dark" style={{  fontSize: '18px', padding: '10px 10px 10px 10px', fontWeight: "500",textAlign:"center" }}>${data.walletBalance}</td>
                                                                        <td className="text-dark" style={{ fontSize: '18px',textAlign:"center", fontWeight: "500", padding: '10px 10px 10px 10px' }}>{moment(data.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
                                                                    </tr>
                                                                )
                                                            })

                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="table-filter-info">

                                                <div className="dt-pagination">
                                                    <ul className="dt-pagination-ul">
                                                        <li className={`dt-item ${currentPage === 1 ? 'disabled' : ''}`}><a className="dt-link" onClick={prevPageClick}>Prev</a></li>
                                                        {
                                                            arrOfCurrButtons.map((data, index) => {
                                                                return (
                                                                    <li key={index} className={`dt-item ${currentPage === data ? 'active' : ''}`}><a className="dt-link" onClick={() => SetCurrentPage(data)}>{data}</a></li>
                                                                )
                                                            })
                                                        }
                                                        <li className={`dt-item ${currentPage === numOfButtons.length ? 'disabled' : ''}`}><a className="dt-link" onClick={nextPageClick}>Next</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    )
}

export default Transaction


